var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2611_12446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4443 12C24.4443 5.37258 19.0718 0 12.4443 0C5.81691 0 0.444336 5.37258 0.444336 12C0.444336 17.9895 4.83254 22.954 10.5693 23.8542V15.4688H7.52246V12H10.5693V9.35625C10.5693 6.34875 12.3609 4.6875 15.1019 4.6875C16.4144 4.6875 17.7881 4.92188 17.7881 4.92188V7.875H16.275C14.7843 7.875 14.3193 8.80008 14.3193 9.75V12H17.6475L17.1154 15.4688H14.3193V23.8542C20.0561 22.954 24.4443 17.9895 24.4443 12Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2611_12446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.444336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d7b232c87b755f05920eb40df50ec796.svg";
export { ForwardRef as ReactComponent };